
<div class="top-container">

    <!--
    ensMetadataLoading: {{ensMetadataLoading}}<br/>
    filteredMeta.length: {{filteredMeta.length}}<br/>
    -->
    <div *ngIf="ensMetadataLoading" class="retro ensLoading">
        <span>Fetching ENS metadata</span> <app-loader></app-loader>
    </div>

    <div *ngIf="!ensMetadataLoading && (ensMetadata$ | async) as metadata" class="metadata-details" [ngClass]="{'expandable' : filteredMeta.length > 1, 'hasDescription': hasDescription}" #details>
        <h3 *ngIf="metadata.description">
            <span [options]="{
            interactive: true,
            content: metadata.description,
            placement: 'bottom'
            }" tippy>{{ metadata.description }}</span>
        </h3>
        <div class="metadata-container">

            <span *ngFor="let item of filteredMeta; let last = last">
                
                <!-- because of ethfollow, 3: ens + followings + followers -->
                <ng-template [ngTemplateOutlet]="emptyMetadata" *ngIf="item.label == 'followingCount' && filteredMeta.length <= 3" />

                <hr *ngIf="item.label == 'followingCount'" />

                <span class="metadata-item">

                    @if (item.label == 'followingCount' || item.label == 'followerCount') {
                        <span class="label bold">{{ item.value }}</span>
                        <span class="icon" [ngSwitch]="item.label">
                            <ng-template *ngSwitchCase="'followerCount'" [ngTemplateOutlet]="followerCountIcon"></ng-template>
                            <ng-template *ngSwitchCase="'followingCount'" [ngTemplateOutlet]="followingCountIcon"></ng-template>
                        </span>
                    } @else {
                        <span class="label">
                            <span class="icon" [ngSwitch]="item.label">
                                <ng-template *ngSwitchCase="'discord'" [ngTemplateOutlet]="discordIcon"></ng-template>
                                <ng-template *ngSwitchCase="'x'" [ngTemplateOutlet]="xIcon"></ng-template>
                                <ng-template *ngSwitchCase="'telegram'" [ngTemplateOutlet]="telegramIcon"></ng-template>
                                <ng-template *ngSwitchCase="'url'" [ngTemplateOutlet]="linkIcon"></ng-template>
                                <ng-template *ngSwitchCase="'github'" [ngTemplateOutlet]="githubIcon"></ng-template>
                                <ng-template *ngSwitchCase="'ens'" [ngTemplateOutlet]="ensIcon"></ng-template>
                                <ng-container *ngSwitchDefault></ng-container>
                            </span>  
                        </span>
                        <span class="value">{{ item.value }}</span>
                    }
                </span>
                
            </span>

            <div class="baseline">Ethereum Follow Protocol</div>
        </div>

        <div *ngIf="filteredMeta.length === 0">No metadata</div>
        

        <div class="toggler" (click)="toggle()">
            <div class="padder"></div>
            <div class="icon"><ng-template [ngTemplateOutlet]="menuIcon" /></div>
        </div>
    </div>

</div>

<ng-template #emptyMetadata>
    <div style="font-size: 1.4rem;" class="not-connected">
        <!--ng-container *ngIf="!(stateSvc.web3Connected$ | async) || (address | lowercase) === ((stateSvc.walletAddress$ | async) | lowercase)"-->
        <ng-container>
            No metadata
            <br/>
            <a href="https://app.ens.domains/my/profile" style="display: block; margin: 0 0 1rem 0;" class="pink" target="_blank">Update your ENS metadata</a>
            Personalize your {{environment.tokenName}} profile page by adding your 
            Discord, X, Telegram, URL, and even a description.
        </ng-container>
    </div>
</ng-template>
<ng-template #menuIcon>
    <svg height="15" viewBox="0 0 9 15" width="9" xmlns="http://www.w3.org/2000/svg"><path d="m6 6h3v3h-3zm-3-3h3v3h-3zm0 6h3v3h-3zm-3-9h3v3h-3zm0 12h3v3h-3z" fill-rule="evenodd" fill="currentColor" /></svg>
</ng-template>
<ng-template #discordIcon>
    <svg id="Discord" xmlns="http://www.w3.org/2000/svg" width="64" height="49" viewBox="0 0 64 49">
        <path class="cls-1" d="M47.97,39.26l1.43,1.17a47.045,47.045,0,0,1-5.46,2.6c0,0.011.748,1.545,1.56,2.86s1.82,2.6,1.82,2.6a39.169,39.169,0,0,0,9.1-3.64,56.453,56.453,0,0,0,7.02-4.42,47.39,47.39,0,0,0,.26-5.72A56,56,0,0,0,53.95,4.03a40.976,40.976,0,0,0-6.5-2.34C43.444,0.577,40.95,0,40.95,0L39.13,3.51a39.075,39.075,0,0,0-7.15-.52,44.359,44.359,0,0,0-7.41.52L22.75,0s-2.494.577-6.5,1.69a40.976,40.976,0,0,0-6.5,2.34A56,56,0,0,0,0,34.71a47.39,47.39,0,0,0,.26,5.72,56.454,56.454,0,0,0,7.02,4.42,39.169,39.169,0,0,0,9.1,3.64s1.008-1.285,1.82-2.6,1.56-2.849,1.56-2.86a47.045,47.045,0,0,1-5.46-2.6l1.43-1.17A37.514,37.514,0,0,0,47.97,39.26ZM21.32,20.28c4.479,0,5.72,4.268,5.72,6.24,0,2.466-1.2,6.63-5.72,6.63-4.771,0-5.85-4.576-5.85-6.5C15.47,24.536,16.86,20.28,21.32,20.28Zm21.19,0c4.479,0,5.72,4.268,5.72,6.24,0,2.466-1.2,6.63-5.72,6.63-4.771,0-5.85-4.576-5.85-6.5C36.66,24.536,38.05,20.28,42.51,20.28Z"/>
      </svg>      
</ng-template>
<ng-template #xIcon>
    <svg id="X" xmlns="http://www.w3.org/2000/svg" width="53" height="48" viewBox="0 0 53 48">
        <path class="cls-1" d="M0,48H5L21.983,29.239,36,48H53L31,20,49,0H44L28.428,17.33,15,0H0L19.934,26.507ZM7,3h6L46,45H39Z"/>
    </svg>        
</ng-template>
<ng-template #ensIcon>
    <svg id="ENS" xmlns="http://www.w3.org/2000/svg" width="69" height="76" viewBox="0 0 69 76">
        <path class="cls-1" d="M33.046,0L11.493,35.739A28.258,28.258,0,0,1,7.827,28a14.653,14.653,0,0,1,1.3-10.245A10.882,10.882,0,0,1,11.767,14.8C12.408,14.351,33.046,0,33.046,0ZM3.715,23.746s-0.137,1.121-.137,1.713A23.769,23.769,0,0,0,5.462,32.9c0.378,0.832,3.187,5.551,3.187,5.551s5.626,9.172,7.093,11.479,9.034,14.1,10.588,16.345S33,76,33,76s-3.078-1.827-6.978-4.556S16.377,64.82,11.185,61.1,4.773,55.2,3,52.118,0.122,44.5.014,39.337a27.514,27.514,0,0,1,1.131-9.766A44.273,44.273,0,0,1,3.715,23.746ZM36,76L57.058,40.537a28.264,28.264,0,0,1,3.665,7.744,14.658,14.658,0,0,1-1.3,10.246,10.88,10.88,0,0,1-2.637,2.947C56.143,61.925,36,76,36,76ZM64.833,52.53s0.137-1.121.137-1.713a23.778,23.778,0,0,0-1.884-7.436C62.708,42.548,59.9,37.83,59.9,37.83s-5.623-9.172-7.09-11.479-9.03-14.1-10.584-16.345S35.513,0,35.513,0s3.123,2.1,7.022,4.831,9.64,6.625,14.831,10.348,6.409,5.893,8.186,8.978,2.872,7.623,2.98,12.781A27.525,27.525,0,0,1,67.4,46.7,44.276,44.276,0,0,1,64.833,52.53Z"/>
    </svg>               
</ng-template>
<ng-template #githubIcon>
    <svg id="Github" xmlns="http://www.w3.org/2000/svg" width="60" height="64" viewBox="0 0 60 64">
        <path class="cls-1" d="M48,64H22l0.062-5.516a24.85,24.85,0,0,1-6.659,1.2c-3.08,0-6.437-.759-8.584-4.011-1.663-2.519-.869-2.838-2.647-5.455A11.6,11.6,0,0,0,.8,46.851,1.784,1.784,0,0,1,0,45.728c0-.2.222-0.8,1.524-0.8a5.554,5.554,0,0,1,3.61,1.364c1.875,1.389,2.241,2.857,3.209,3.931s2.385,2.487,6.338,2.487a19.417,19.417,0,0,0,7.461-1.685,10.117,10.117,0,0,1,2.086-6.257,15.083,15.083,0,0,1,3.931-3.771s-17.248.116-17.248-19.334A16.235,16.235,0,0,1,14.842,10.59S14.12,9.385,14.12,6.1A17.608,17.608,0,0,1,15.243.08,3.536,3.536,0,0,1,16.205,0c3.788,0,9.386,4.172,9.386,4.172a32.492,32.492,0,0,1,9.787-1.284c6.1,0,9.146,1.364,9.146,1.364S49.913,0,54.071,0a3.89,3.89,0,0,1,.8.08A17.763,17.763,0,0,1,56,6.177a14.917,14.917,0,0,1-.722,4.493s3.851,3.594,3.851,10.59S56.854,34,53.189,36.9C48.556,40.57,41.8,40.915,41.8,40.915a18.256,18.256,0,0,1,4.493,4.332A10.755,10.755,0,0,1,48.055,51.5C48.055,53.691,48,64,48,64Z"/>
    </svg>       
</ng-template>
<ng-template #linkIcon>
    <svg id="URL" xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67">
        <path class="cls-1" d="M46.5,29.041l-5.7,5.7s-3.332-8.4-11.1-8.4c-5.052,0-7.2,2.1-7.2,2.1L8.7,42.241s-1.8,1.959-1.8,6.3c0,3.436,2.779,10.8,11.1,10.8a12.646,12.646,0,0,0,7.2-2.4l4.8-4.8s1.473,1.2,5.1,1.2,4.5-.6,4.5-0.6l-10.2,9.9s-3.254,3.9-10.2,3.9S0,61.283,0,48.241c0-8.313,4.2-11.7,4.2-11.7l14.7-14.7s3.163-3.9,11.1-3.9a15.567,15.567,0,0,1,9.3,2.7C43.385,23.251,46.5,29.041,46.5,29.041ZM20.455,37.5l5.7-5.7s3.332,8.4,11.1,8.4c5.052,0,7.2-2.1,7.2-2.1l13.8-13.8s1.8-1.959,1.8-6.3c0-3.436-2.779-10.8-11.1-10.8a12.646,12.646,0,0,0-7.2,2.4l-4.8,4.8s-1.473-1.2-5.1-1.2-4.5.6-4.5,0.6l10.2-9.9S40.809,0,47.755,0s19.2,5.258,19.2,18.3c0,8.313-4.2,11.7-4.2,11.7l-14.7,14.7s-3.163,3.9-11.1,3.9a15.568,15.568,0,0,1-9.3-2.7C23.571,43.293,20.455,37.5,20.455,37.5Z"/>
    </svg>      
</ng-template>
<ng-template #telegramIcon>
    <svg id="Telegram" xmlns="http://www.w3.org/2000/svg" width="62" height="52" viewBox="0 0 62 52">
        <path class="cls-1" d="M23.317,48.625L24.2,34.195,50.623,10.219a1.291,1.291,0,0,0,.444-0.666,1.006,1.006,0,0,0-1.332-.222c-0.323.157-33.3,21.09-33.3,21.09L1.783,25.759S0.007,25.292.007,23.983a2.588,2.588,0,0,1,1.554-2l55.5-21.534a5.653,5.653,0,0,1,2-.444c1,0,2.886.334,2.886,3.108,0,1.9-9.546,45.732-9.546,45.732s-0.4,3.108-2.886,3.108a2.338,2.338,0,0,1-1.776-.444L33.085,40.633l-7.77,7.326A2.468,2.468,0,0,1,23.317,48.625Z"/>
    </svg>      
</ng-template>
<ng-template #followingCountIcon>
    Following
</ng-template>
<ng-template #followerCountIcon>
    Followers
</ng-template>
